import { PiWrenchFill } from "react-icons/pi";
import { CgCloseO } from "react-icons/cg";
import { BiBarChartSquare } from "react-icons/bi";
import { IoCalendarOutline } from "react-icons/io5";
import { Routes } from "../enums/Routes";

export const getHeaderIcon = (path) => {
  switch (path) {
    case Routes.Demos:
    case Routes.Showrooms:
      return <PiWrenchFill />;
    case Routes.Blocks:
      return <CgCloseO />;
    case Routes.Reports:
      return <BiBarChartSquare />;
    case Routes.Calendar:
      return <IoCalendarOutline />;
    default:
      return;
  }
};

export const getHeaderTitle = (path) => {
  switch (path) {
    case Routes.Demos:
      return "Demo Management";
    case Routes.Showrooms:
      return "Showroom Management";
    case Routes.Blocks:
      return "Block Management";
    case Routes.Calendar:
      return "Calendar";
    case Routes.Reports:
      return "Reports";
    default:
      return;
  }
};

export const getHeaderClass = (path) => {
  switch (path) {
    case Routes.Demos:
      return "demos";
    case Routes.Showrooms:
      return "showrooms";
    case Routes.Blocks:
      return "blocks";
    case Routes.Calendar:
      return "calendar";
    case Routes.Reports:
      return "reports";
    default:
      return "";
  }
};
